<template>
  <nav id="smart-header-nav" class="nav">
    <UiBtn
      class="search-icon"
      :size="buttonsSize"
      icon-only
      color="default"
      data-id="header-search"
      rel="nofollow"
      icon="navigation/search-normal"
      @click="openSearch"
    />
    <template v-if="isLoggedIn">
      <div @click="toggleDropdown('balance')">
        <CashboxBalanceItem
          v-model="balance"
          class="nav__balance"
          :label="$tc('headerData.balance')"
        />
      </div>

      <UiBtn
        class="nav__cashbox"
        color="primary"
        :text="$tc('buttons.payin')"
        :size="buttonsSize"
        data-id="header-cashbox-link"
        :data-gtm-id="GA_HEADER_CLICK_BTN_CASHBOX"
        rel="nofollow"
        icon="cashbox/plus"
        @click="toCashbox"
      />
    </template>

    <template v-else>
      <UiBtn
        class="nav__login"
        color="default"
        :text="$tc('logInBtn.title')"
        :size="buttonsSize"
        @click="openRegModal"
      />
      <UiBtn
        class="nav__register"
        color="primary"
        :size="buttonsSize"
        :text="$tc('registration')"
        :to="$paths.registration"
      />
    </template>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { HEADER } from '@/components/App/AppHeader/enum'
import CashboxBalanceItem from '@/components/Cashbox/Navigation/BalanceItem'
import { formatNumberFilter } from '@/util/helpers/vueFilters'
import { GTM_CASHBOX } from '@/constants/gtm'

export default {
  name: 'SmartHeaderNav',
  components: { CashboxBalanceItem },
  data() {
    return {
      GA_HEADER_CLICK_BTN_CASHBOX: GTM_CASHBOX.ID.ga_header_click_btn_cashbox,
    }
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn', 'user', 'isUserVerified']),
    balance() {
      return formatNumberFilter(this.user.balance, { format: 'currency', isShowSymbol: false })
    },
    buttonsSize() {
      return { default: 'm', 'tablet-album': 'l' }
    },
  },
  methods: {
    ...mapActions('base', ['act_setHeader', 'toggleDropdown']),
    ...mapActions('lobby', ['toggle_openSearch']),
    ...mapActions('globalModal', ['open_globalModalVerifyBeforePay']),
    toCashbox() {
      this.$router.push(this.$paths.cashbox)
    },
    async openSearch() {
      await this.act_setHeader({ type: HEADER.FULL })

      setTimeout(() => {
        this.toggle_openSearch(true)
      }, 500)
    },
    openRegModal() {
      this.$newModal.openAuthWithLastMethod()
    },
  },
}
</script>

<style lang="scss" scoped src="./style.scss" />
